import React from 'react';
export function ResultsNumbers() {
  const stats = [{
    metric: '5-10 hours of time saved each week',
    context: 'HTEC Group product team, reported by the Head of Product within three months of program completion.'
  }, {
    metric: 'Idea to working prototype in 6 hours, with zero coding experience',
    context: 'Dan Beatrup, Senior Product Manager.'
  }, {
    metric: 'From course participant to leading an AI development team in 7 months',
    context: 'Kate Mosley, now presenting AI roadmaps to Google, Amazon, and AT&T.'
  }, {
    metric: '30 minutes to several hours saved per person, per week, within 30 days',
    context: 'Motorola Solutions, two product teams after a workshop engagement.'
  }, {
    metric: 'From 0% regular AI use to executives coaching colleagues in four sessions',
    context: 'Snøhetta executive team, architecture and design.'
  }];
  return <section className="w-full bg-white pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-245" data-mp="at5tb62vjmxx">
      <div className="max-w-7xl mx-auto" data-id="element-246" data-mp="5vdya36xnkpi">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-brand-navy mb-16 leading-tight" data-id="element-247" data-mp="5um5f04q012x">
          Results
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-248" data-mp="fknx01wa81ml">
          {stats.map((stat, index) => <div key={index} className="bg-brand-light-gray p-10 md:p-14 rounded-lg shadow-sm border-t-4 border-brand-orange flex flex-col" data-id="element-249" data-mp="3o07lyopx6xvu" data-mpi={index}>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-6 leading-tight flex-grow" data-id="element-250" data-mp="vrne0ekugjv">
                {stat.metric}
              </h2>
              <p className="text-xl text-brand-gray-light" data-id="element-251" data-mp="3s1ausr9jvtnk">{stat.context}</p>
            </div>)}
        </div>
      </div>
    </section>;
}